import Icon from "@/v2-ui/icon"
import Button from "@/v2-backoffice-client/components/button"
import type { LayerAiIdentityProposal } from "@/v2-backoffice-client/layer/ai/layer.ai.types"

export type LayerAiIdentityCardProps = {
  identity: LayerAiIdentityProposal
  onApply(identity: LayerAiIdentityProposal): void
  onDismiss(): void
}

/**
 * Create mode: the assistant's proposed feature code and texts for the new
 * layer. Applying fills the create form's identity fields — the operator
 * can still edit them there before creating.
 */
function LayerAiIdentityCard(props: LayerAiIdentityCardProps) {
  const { identity, onApply, onDismiss } = props

  return (
    <div className="flex shrink-0 flex-col gap-0.5 rounded-md border border-primary/40 bg-primary/5 px-2 py-1.5">
      <p className="flex items-center gap-1.5 text-xs">
        <Icon src="id-badge" size={12} className="shrink-0 text-primary" />
        <span className="truncate font-mono text-[11px]">
          {identity.FeatureCode}
        </span>
        <span className="flex-1" />
        <Button
          size="tiny"
          variant="ghost"
          data-feature-code="UI_BackofficeLayers_AiAssistant_IdentityDismiss"
          onClick={onDismiss}
        >
          Dismiss
        </Button>
        <Button
          size="tiny"
          variant="outline"
          iconSrc="check"
          data-feature-code="UI_BackofficeLayers_AiAssistant_IdentityApply"
          onClick={() => onApply(identity)}
        >
          Use identity
        </Button>
      </p>
      <p
        className="line-clamp-2 text-xs text-muted-foreground"
        title={`${identity.Name}${identity.Description ? ` — ${identity.Description}` : ""}`}
      >
        <span className="text-foreground">{identity.Name}</span>
        {identity.Description && <> — {identity.Description}</>}
      </p>
    </div>
  )
}

export default LayerAiIdentityCard
